import {css} from 'styled-components';

// This is simply a connection between the base styles and the component that utilizes them.
// Without it, we might overlook removing this code when we refactor or even eliminate the animations.
export enum GLOBAL_KEYFRAMES {
  fadeEnter = 'fadeEnter',
  fadeExit = 'fadeExit',
}

export const keyFrames = css`
  @keyframes fadeEnter {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes fadeExit {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
`;
